import React from 'react';
import Spinner from 'react-bootstrap/Spinner';

import descarga from 'assets/images/descarga.png';
import check from 'assets/images/check.png';

import './styles.scss';

export const DESCARGADO_TITLE = 'Descargado. Verifique la carpeta de descargas';

const DownloadIconButton = ({ status = 'idle', onClick }) => {
    return (
        <button
            type="button"
            className={`descarga download-icon-button ${status}`}
            onClick={onClick}
            disabled={status !== 'idle'}
            title={status === 'done' ? DESCARGADO_TITLE : status === 'loading' ? 'Descargando...' : 'Descargar'}
        >
            {status === 'loading' && <Spinner animation="border" size="sm" role="status" />}
            {status === 'done' && <img src={check} alt="descargado" />}
            {status === 'idle' && <img src={descarga} alt="descarga" />}
        </button>
    );
};

export default DownloadIconButton;
